import { cva } from '@vizit/theme';

const rowClasses = cva({
  base: ['bg-white'],
  variants: {
    disabled: {
      false: '',
      true: 'opacity-50',
    },
  },
});

export { rowClasses };
